import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../../services/translation/translation.service';

@Pipe({
  name: 'translate',
  pure: false // This ensures the pipe recalculates when the service data changes
})
export class TranslationPipe implements PipeTransform {
  constructor(private translationService?: TranslationService) { }

  transform(value: string, params?: { [key: string]: any }): string {
    return this.translationService!.translate(value, params);
  }
}
